var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"data-chart"},[_c('div',{staticClass:"status-value"},[_vm._v(" "+_vm._s(_vm.getValuesData)+" "+_vm._s(Object.keys(_vm.chart.reporting_data[0].report_data).includes('unit') ? _vm.chart.reporting_data[0].report_data.unit : '')+" ")]),_c('div',{staticClass:"status-label"},[_vm._v(" "+_vm._s(_vm.chartTitle)+" ")]),_c('br')])
}
var staticRenderFns = []

export { render, staticRenderFns }